// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-swapper{position:absolute;width:300px}.location-swapper>*{margin-bottom:0.5em}.location-swapper>*:last-child{margin-bottom:0}.location-swapper-desktop{left:100%;position:absolute;bottom:0;width:300px;z-index:-1}.location-swapper-desktop>*{margin-bottom:0.5em}.location-swapper-desktop>*:last-child{margin-bottom:0}.location-swapper-mobile{bottom:100%;right:0;width:100%}\n", ""]);
// Exports
module.exports = exports;
